import { Controller } from "@hotwired/stimulus"

// Nasconde/mostra le chip evento per calendario (client-side, non persistito).
export default class extends Controller {
  static targets = ["legend"]

  toggle(event) {
    const key = event.currentTarget.dataset.calendarKey
    const hidden = event.currentTarget.classList.toggle("opacity-40")
    this.element
      .querySelectorAll(`[data-calendar-key="${key}"]`)
      .forEach((el) => {
        // The legend entry itself carries the same data-calendar-key (so the
        // click target is included in this query) — skip it, or toggling
        // "hidden" would make the button disappear and un-clickable.
        if (el !== event.currentTarget) el.hidden = hidden
      })
  }
}
